module.exports = new __parcel__URL__("greyscale.0d398306.png").toString();